const sections = document.querySelectorAll('section.vacancy-header');

function getWpAdminBarHeight() {
	const adminBar = document.getElementById('wpadminbar');
	return adminBar ? adminBar.offsetHeight : 0;
}

function stickyProgress(raw, linkCount) {
	if (linkCount <= 1) {
		return raw;
	}

	const stepCount = linkCount - 1;
	const position = raw * stepCount;
	const stepIndex = Math.min(stepCount - 1, Math.floor(position));
	const stepFraction = position - stepIndex;

	// Hang near each word before easing into the next one.
	const hangStart = 0.55;
	let stickyFraction = stepFraction;

	if (stepFraction < hangStart) {
		const t = stepFraction / hangStart;
		stickyFraction = t * t * hangStart;
	} else {
		const t = (stepFraction - hangStart) / (1 - hangStart);
		stickyFraction = hangStart + t * t * (3 - 2 * t) * (1 - hangStart);
	}

	return (stepIndex + stickyFraction) / stepCount;
}

sections.forEach(section => {
	const links = section.querySelectorAll('[data-links] > a');
	const linksWrapper = section.querySelector('[data-links]');
	const linksParent = section.querySelector('[data-links-parent]');

	let snapTimeout = null;
	let isSnapping = false;

	const getMetrics = () => {
		const wpAdminBarHeight = getWpAdminBarHeight();
		const viewportHeight = window.innerHeight - wpAdminBarHeight;
		const scrollRange = section.offsetHeight - viewportHeight;
		const distance = Math.max(0, linksWrapper.offsetHeight - linksParent.offsetHeight);

		return {
			wpAdminBarHeight,
			scrollRange,
			distance,
		};
	};

	const getRawProgress = () => {
		const { wpAdminBarHeight, scrollRange } = getMetrics();
		const sectionRect = section.getBoundingClientRect();
		const top = sectionRect.top - wpAdminBarHeight;

		if (scrollRange <= 0) {
			return 0;
		}

		return Math.min(1, Math.max(0, -top / scrollRange));
	};

	const getScrollYForProgress = (progress) => {
		const { wpAdminBarHeight, scrollRange } = getMetrics();
		const sectionRect = section.getBoundingClientRect();
		const top = sectionRect.top - wpAdminBarHeight;

		return window.scrollY + top + progress * scrollRange;
	};

	const getSnapIndex = (progress) => {
		if (links.length <= 1) {
			return 0;
		}

		return Math.round(progress * (links.length - 1));
	};

	const applyProgress = (rawProgress) => {
		const { distance } = getMetrics();
		const displayProgress = stickyProgress(rawProgress, links.length);
		const translateY = -displayProgress * distance;

		linksWrapper.style.transform = `translate3d(0, ${translateY}px, 0)`;

		const activeIndex = getSnapIndex(displayProgress);

		links.forEach((link, i) => {
			const isActive = i === activeIndex;
			link.classList.toggle('active', isActive);
			link.setAttribute('aria-current', isActive ? 'true' : 'false');
		});
	};

	const snapToNearestWord = () => {
		if (isSnapping || links.length <= 1) {
			return;
		}

		const { scrollRange } = getMetrics();

		if (scrollRange <= 0) {
			return;
		}

		const rawProgress = getRawProgress();
		const snapIndex = getSnapIndex(rawProgress);
		const snapProgress = snapIndex / (links.length - 1);

		if (Math.abs(rawProgress - snapProgress) < 0.002) {
			applyProgress(snapProgress);
			return;
		}

		const targetScrollY = getScrollYForProgress(snapProgress);

		isSnapping = true;
		window.scrollTo({
			top: targetScrollY,
			behavior: 'smooth',
		});

		window.setTimeout(() => {
			isSnapping = false;
			applyProgress(snapProgress);
		}, 450);
	};

	const onScroll = () => {
		applyProgress(getRawProgress());
	};

	const onScrollEnd = () => {
		window.clearTimeout(snapTimeout);
		snapTimeout = window.setTimeout(snapToNearestWord, 80);
	};

	links.forEach(link => {
		link.style.transformOrigin = 'center center';
	});

	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('scroll', onScrollEnd, { passive: true });

	if ('onscrollend' in window) {
		window.addEventListener('scrollend', snapToNearestWord);
	}

	window.addEventListener('resize', onScroll, { passive: true });
	onScroll();
});
